import React from 'react';
import KPICard from '../components/KPICard';

function formatNote(note) {
  if (note == null) return '—';
  const n = Number(note);
  if (Number.isNaN(n)) return '—';
  return n.toFixed(1).replace('.', ',');
}

export default function KPIGrid({ restaurant, stats }) {
  const note = restaurant?.note_actuelle ?? restaurant?.note_depart ?? null;
  const nbAvis = restaurant?.nb_avis_total ?? restaurant?.avis_depart ?? 0;
  const satisfaits = stats?.satisfaits ?? 0;
  const feedbacks = stats?.feedbacks_negatifs ?? 0;
  const rps = restaurant?.rps_score ?? 0;

  return (
    <div style={styles.grid}>
      <KPICard
        label="Note Google"
        value={formatNote(note)}
        subtitle={`${nbAvis} avis · ⭐`}
        accent="default"
      />
      <KPICard
        label="Clients satisfaits"
        value={satisfaits}
        subtitle="ce mois"
        accent="success"
      />
      <KPICard
        label="Feedbacks négatifs"
        value={feedbacks}
        subtitle="→ stable"
        accent="danger"
      />
      <KPICard
        label="Score de réputation RPS™"
        value={rps}
        subtitle="/100"
        accent="dark"
        progress={rps}
      />
    </div>
  );
}

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
  },
};
